import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {updateDocumentTitle} from "../../Utils/Common";
import PageLayout from "../Layout/PageLayout";
import {Card, Tabs, FormField, TextInput, TextArea, Select, Button, DataTable, StatusBadge} from "../UI";
import DatePicker from "../Views/DatePicker";
import TimePicker from "../Views/TimePicker";

const Broadcasts = props => {

    let d = new Date();

    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [historyList, setHistoryList] = useState([]);
    const [scheduledList, setScheduledList] = useState([]);

    const [audience, setAudience] = useState('active_clients');
    const [commType, setCommType] = useState('sms');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [broadType, setBroadType] = useState('instant');
    const [broadDate, setBroadDate] = useState('');
    const [broadMonth, setBroadMonth] = useState('');
    const [broadYear, setBroadYear] = useState('');

    const [broadTime, setBroadTime] = useState('');
    const [broadMinute, setBroadMinute] = useState('');

    const [customAudience, setCustomAudience] = useState('');

    const [tab, setTab] = useState('new');

    const columns = [
        {
            name: 'Audience',
            selector: 'audience'
        },
        {
            name: 'Medium',
            selector: 'communication_medium',
        },
        {
            name: 'Type',
            selector: 'broadcast_type',
        },
        {
            name: 'Time',
            cell: row => <div><span>{row.broadcast_date_string}</span></div>,
        },
        {
            name: 'Subject',
            cell: row => <div><span>{row.subject}</span></div>,
        },
        {
            name: 'Message',
            cell: row => <div><span>{row.message}</span></div>,
        },
        {
            name: 'Status',
            cell: row => <StatusBadge tone={row.sent ? "success" : "warn"}>{row.sent ? "SENT" : "PENDING"}</StatusBadge>,
        },
        {
            name: '',
            cell: row => row.sent ? '-' : <Button variant="danger" size="sm"
                                                  onClick={e => deleteBroadcast(row.id)}>Delete</Button>,
        },
    ]


    useEffect(() => {
        updateDocumentTitle("Broadcasts")
        loadHistory()
        loadScheduledHistory()
    }, []);

    function deleteBroadcast(id) {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true)
        postData(Endpoints.DELETE_BROADCAST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    loadScheduledHistory()
                    loadHistory()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    const submitForm = e => {
        e.preventDefault();

        let data = new FormData();
        data.append("audience", audience)
        data.append("comm_type", commType)
        data.append("subject", subject)
        data.append("message", message)
        data.append("custom_audience", customAudience)
        data.append("broadcast_time", broadTime)
        data.append("broadcast_minute", broadMinute)
        data.append("broadcast_date", broadDate)
        data.append("broadcast_month", broadMonth)
        data.append("broadcast_year", broadYear)
        data.append("broadcast_type", broadType)

        setIsLoading(true);

        postData(Endpoints.SEND_BROADCAST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setMessage('');
                    setSubject('');
                    if (broadType === "instant") {
                        loadHistory()
                    } else {
                        loadScheduledHistory()
                    }

                    Notify(res.data, SUCCESS);
                } else {
                    if (Array.isArray(res.message)) {
                        Notify(res.message[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    function loadHistory() {
        let data = new FormData();
        data.append("sent", 1);
        setIsLoading(true)
        postData(Endpoints.LIST_BROADCAST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setHistoryList(res.data || []);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadScheduledHistory() {
        let data = new FormData();
        setIsLoading(true)
        postData(Endpoints.LIST_SCHEDULED_BROADCAST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setScheduledList(res.data || []);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    return (
        <PageLayout title="Broadcasts">
            <Tabs
                tabs={[
                    {key: "new", label: "Send a new broadcast message"},
                    {key: "scheduled", label: "Scheduled pending broadcasts"},
                    {key: "previous", label: "Sent broadcasts"},
                ]}
                value={tab}
                onChange={setTab}
            />

            {tab === "new" &&
            <Card style={{maxWidth: 640}}>
                <form onSubmit={submitForm}>
                    <FormField label="Communication medium">
                        <Select value={commType}
                                onChange={({target}) => setCommType(target.value)}>
                            <option value={"sms"}>SMS</option>
                            <option value={"email"}>Email</option>
                            <option value={"push"}>Push notification</option>
                        </Select>
                    </FormField>

                    <FormField label="Select audience">
                        <Select value={audience}
                                onChange={({target}) => setAudience(target.value)}>
                            <option value={"active_clients"}>All active clients</option>
                            <option value={"inactive_clients"}>Inactive clients</option>
                            <option value={"active_riders"}>All active riders</option>
                            <option value={"inactive_riders"}>Inactive riders</option>
                            {commType !== "push" &&
                            <option value={"custom"}>Custom audience</option>
                            }
                        </Select>
                    </FormField>

                    {audience === "custom" &&
                    <FormField label={`Separate ${commType === "sms" ? "phone numbers" : "emails"} with commas`}>
                        <TextArea
                            rows={5}
                            placeholder={"Separate with commas"}
                            value={customAudience}
                            onChange={e => setCustomAudience(e.target.value)}
                        />
                    </FormField>
                    }

                    <FormField label="Subject">
                        <TextInput type="text"
                                   placeholder={"Subject"}
                                   value={subject}
                                   onChange={e => setSubject(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Message"
                               hint={"{{name}} will be replaced with recipient's name. e.g Dear {{name}}"}>
                        <TextArea
                            rows={5}
                            placeholder={"Message"}
                            value={message}
                            onChange={e => setMessage(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Broadcast type">
                        <Select value={broadType}
                                onChange={({target}) => setBroadType(target.value)}>
                            <option value={"instant"}>Instant</option>
                            <option value={"scheduled"}>Schedule</option>
                        </Select>
                    </FormField>

                    {broadType === "scheduled" &&
                    <div>
                        <DatePicker
                            onDateSelected={(pickerDate, pickerMonth, pickerYear) => {
                                setBroadDate(pickerDate)
                                setBroadMonth(pickerMonth)
                                setBroadYear(pickerYear)
                            }}/>

                        <TimePicker onTimeSelected={(pickerTime, pickerMinute) => {
                            console.log(pickerTime, pickerMinute)
                            setBroadTime(pickerTime)
                            setBroadMinute(pickerMinute)
                        }}/>
                    </div>
                    }

                    <Button type="submit" loading={isLoading}>
                        {broadType === "scheduled" ? "Schedule" : "Send"} broadcast
                    </Button>
                </form>
            </Card>
            }

            {tab === "scheduled" &&
            <Card padded={false}>
                <DataTable
                    columns={columns}
                    data={scheduledList}
                    pointerOnHover={true}
                    noHeader={true}
                />
            </Card>
            }

            {tab === "previous" &&
            <Card padded={false}>
                <DataTable
                    columns={columns}
                    data={historyList}
                    pointerOnHover={true}
                    noHeader={true}
                />
            </Card>
            }
        </PageLayout>
    )
};

export default Broadcasts;
